import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgeLoopIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 5h18M3 19h18" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 5v14M18 5v14",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.5,
			d: "M3 12h18"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 12,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 12,
			r: 2,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgEdgeLoopIcon;
